import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import { Dialog, FlatButton } from 'material-ui'

const ReviewCommentDialog = ({
  review,
  toggleDialog,
}) => {
  const {
    comment,
    created_at: createdAt,
  } = review
  const formattedDate = moment(createdAt).format('MMM Do, YYYY')
  const header = `Comment left on ${formattedDate}`
  return (
    <Dialog
      open
      onRequestClose={() => toggleDialog(false)}
      maxWidth="sm"
      style={{ zIndex: '9999' }}
    >
      <div style={{ fontSize: '20px', fontWeight: 'bold' }}>
        {header}
      </div>
      <div
        style={{ margin: '10px auto' }}
      >
        {comment}
      </div>
      <FlatButton
        label="Close"
        onClick={() => toggleDialog(false)}
        secondary
      />
    </Dialog>
  )
}

ReviewCommentDialog.propTypes = {
  review: PropTypes.shape({
    comment: PropTypes.string.isRequired,
    created_at: PropTypes.string.isRequired,
  }).isRequired,
  toggleDialog: PropTypes.func.isRequired,
}

export default ReviewCommentDialog



// WEBPACK FOOTER //
// ./src/components/sitewide/Reviews/ReviewCommentDialog.js